import concentration from './concentration/index.vue'
import teacherAssessment from './teacherAssessment/index.vue'
export default {
  concentration,
  teacherAssessment
}
